import type { RouteObject } from 'react-router';
import { ExceptionsPage } from './ExceptionsPage';
import { ExceptionDetailPage } from './ExceptionDetailPage';
import { ResponsibilityPage } from './ResponsibilityPage';

/** path 相对 /v2。详情要带 ?order=<orderId>（老系统没有按 id 取异常的接口） */
export const routes: RouteObject[] = [
  { path: 'exceptions', element: <ExceptionsPage /> },
  { path: 'exceptions/responsibility', element: <ResponsibilityPage /> },
  { path: 'exceptions/:id', element: <ExceptionDetailPage /> },
];
